import FullPageLoading from './FullPageLoading'

export default FullPageLoading
